/* Éditions Saint-Louis, interactions maquette */
(function () {
  // Header au scroll
  const header = document.getElementById('header');
  if (header) {
    // L'accueil a une vidéo hero : header transparent en haut puis compact au scroll.
    // Les pages internes n'ont pas de hero vidéo : header toujours compact (logo sombre lisible).
    if (document.querySelector('.vhero')) {
      const onScroll = () => header.classList.toggle('scrolled', window.scrollY > 6);
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    } else {
      header.classList.add('scrolled');
    }
  }

  // Menu mobile (voile + verrou scroll + croix + Échap)
  const burger = document.getElementById('burger');
  const nav = document.getElementById('nav');
  if (burger && nav) {
    const mobileNav = window.matchMedia('(max-width: 1080px)');
    const backdrop = document.createElement('div');
    backdrop.className = 'nav-backdrop';
    document.body.appendChild(backdrop);
    const shopGroup = nav.querySelector('.nav__shopgroup');
    const shopToggle = nav.querySelector('.nav__shop-toggle');
    const shopLink = nav.querySelector('.nav__shop');
    const shopFamilies = Array.from(nav.querySelectorAll('[data-shopnav-family]'));
    const shopFamilyToggles = Array.from(nav.querySelectorAll('.shopnav-family__toggle'));
    let inertedByNav = [];
    const openShopFamily = family => {
      shopFamilies.forEach(item => {
        const open = item === family;
        item.classList.toggle('is-open', open);
        const toggle = item.querySelector('.shopnav-family__toggle');
        if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    };
    const closeShopMenu = restoreFocus => {
      if (!shopGroup || !shopToggle) return;
      const wasOpen = shopGroup.classList.contains('is-open');
      const keyboardOpen = !mobileNav.matches && shopGroup.contains(document.activeElement);
      shopGroup.classList.remove('is-open');
      shopToggle.setAttribute('aria-expanded', 'false');
      if (restoreFocus && (wasOpen || keyboardOpen)) {
        if (keyboardOpen && shopLink) { shopGroup.classList.add('is-keyboard-closed'); shopLink.focus(); }
        else shopToggle.focus();
      }
    };
    const setPageInert = open => {
      if (open) {
        inertedByNav = Array.from(document.querySelectorAll('.topbar,main,.cagnmini,.footer,.header__logo,.header__actions,.audiodock')).filter(element => !nav.contains(element) && !element.inert);
        inertedByNav.forEach(element => { element.inert = true; });
      } else {
        inertedByNav.forEach(element => { element.inert = false; });
        inertedByNav = [];
      }
    };
    const syncNavAccessibility = () => {
      const open = nav.classList.contains('open');
      if (mobileNav.matches) {
        nav.inert = !open;
        nav.setAttribute('aria-hidden', open ? 'false' : 'true');
      } else {
        nav.inert = false;
        nav.removeAttribute('aria-hidden');
      }
    };
    const setNav = (open) => {
      const wasOpen = nav.classList.contains('open');
      const next = mobileNav.matches && open;
      nav.classList.toggle('open', next);
      backdrop.classList.toggle('open', next);
      document.body.classList.toggle('nav-lock', next);
      burger.classList.toggle('is-open', next);
      burger.setAttribute('aria-expanded', next ? 'true' : 'false');
      if (!next) closeShopMenu();
      if (next) { nav.setAttribute('role', 'dialog'); nav.setAttribute('aria-modal', 'true'); }
      else { nav.removeAttribute('role'); nav.removeAttribute('aria-modal'); }
      setPageInert(next);
      syncNavAccessibility();
      if (next) {
        window.requestAnimationFrame(() => {
          const first = nav.querySelector('a,button:not([disabled])');
          if (first) first.focus();
        });
      } else if (wasOpen) burger.focus();
    };
    burger.addEventListener('click', () => setNav(!nav.classList.contains('open')));
    backdrop.addEventListener('click', () => setNav(false));
    nav.querySelectorAll('a').forEach(a => a.addEventListener('click', () => setNav(false)));
    if (shopGroup && shopToggle) {
      shopToggle.addEventListener('click', () => {
        const open = !shopGroup.classList.contains('is-open');
        shopGroup.classList.toggle('is-open', open);
        shopToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open && shopFamilies.length && !shopFamilies.some(family => family.classList.contains('is-open'))) openShopFamily(shopFamilies[0]);
      });
    }
    shopFamilyToggles.forEach(toggle => toggle.addEventListener('click', () => {
      const family = toggle.closest('[data-shopnav-family]');
      if (!family) return;
      const open = family.classList.contains('is-open');
      if (open) {
        family.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      } else openShopFamily(family);
    }));
    document.addEventListener('click', e => {
      if (shopGroup && !shopGroup.contains(e.target)) closeShopMenu();
    });
    if (shopGroup) shopGroup.addEventListener('focusout', () => window.setTimeout(() => {
      if (!mobileNav.matches && !shopGroup.contains(document.activeElement)) {
        shopGroup.classList.remove('is-keyboard-closed');
        closeShopMenu();
      }
    }, 0));
    if (shopGroup) shopGroup.addEventListener('pointerenter', () => shopGroup.classList.remove('is-keyboard-closed'));
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') {
        if (nav.classList.contains('open')) setNav(false);
        else if (shopGroup && (shopGroup.classList.contains('is-open') || (!mobileNav.matches && shopGroup.contains(document.activeElement)))) closeShopMenu(true);
      }
      if (e.key !== 'Tab' || !mobileNav.matches || !nav.classList.contains('open')) return;
      const focusable = Array.from(nav.querySelectorAll('a,button:not([disabled])')).filter(element => element.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    const onNavBreakpoint = () => {
      if (!mobileNav.matches) setNav(false);
      else syncNavAccessibility();
    };
    if (mobileNav.addEventListener) mobileNav.addEventListener('change', onNavBreakpoint);
    else mobileNav.addListener(onNavBreakpoint);
    syncNavAccessibility();
  }

  // Reveal on scroll
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold: 0.12 });
  const aReveler = document.querySelectorAll('.section__head, .book, .hero-card, .ucard, .mrmr, .school, .pillar, .trio__c, .packnudge, .shop-coffret, .shop-look, .shop-path, .sl-pack-card, .shop-pack-prompt, .shop-offer-card, .shop-pack-link, .shop-context-offer, .shop-wear-stage, .slpack, .slcollection, .slshelf__head, .slgame-pack, .slgift-pack, .slmrmr, .slwear-stage');
  aReveler.forEach(el => { el.classList.add('reveal'); io.observe(el); });
  /* Filet : si l'observateur ne se declenche pas (onglet inactif, animations coupees),
     on montre tout plutot que de laisser des blocs invisibles. */
  const toutMontrer = () => aReveler.forEach(el => el.classList.add('in'));
  setTimeout(toutMontrer, 2500);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) setTimeout(toutMontrer, 900); }, { once: true });
})();

/* Le bandeau d'informations peut être mis en pause, au clavier comme au toucher. */
(function () {
  const bar = document.querySelector('.topbar');
  const control = bar && bar.querySelector('.topbar__pause');
  if (!bar || !control) return;
  control.addEventListener('click', () => {
    const paused = !bar.classList.contains('is-paused');
    bar.classList.toggle('is-paused', paused);
    control.setAttribute('aria-pressed', paused ? 'true' : 'false');
    control.setAttribute('aria-label', paused ? 'Reprendre le bandeau d’informations' : 'Mettre le bandeau d’informations en pause');
    control.querySelector('[aria-hidden]').textContent = paused ? '▶' : 'Ⅱ';
  });
})();

/* La Boutique, sommaire continu, ancres partageables et chapitre actif */
(function () {
  const shop = document.querySelector('[data-slshop]');
  if (!shop) return;
  const entries = Array.from(shop.querySelectorAll('[data-slshop-entry]'));
  const navLinks = Array.from(shop.querySelectorAll('[data-slshop-nav-link]'));
  const panels = Array.from(shop.querySelectorAll('[data-slshop-panel]'));
  const stages = Array.from(shop.querySelectorAll('[data-slshop-stage]'));
  const bookSubnavLinks = Array.from(shop.querySelectorAll('.slrayon--books .slrayon-subnav a[href^="#"]'));
  const valid = new Set(panels.map(panel => panel.dataset.slshopPanel));
  const hashMap = {
    livres: 'livres', 'collections-livres': 'livres', 'je-decouvre': 'livres', 'mon-roi-ma-reine': 'livres',
    jeux: 'jeux', puzzles: 'jeux', eventail: 'jeux', numerique: 'jeux',
    vetements: 'vetements', hoodies: 'vetements', sweats: 'vetements', tshirts: 'vetements', 'tous-vetements': 'vetements',
    cadeaux: 'cadeaux', 'grands-cadeaux': 'cadeaux', 'ensembles-cadeaux': 'cadeaux', affiches: 'cadeaux', peluches: 'cadeaux'
  };
  let active = 'livres';
  const safeHash = () => {
    try { return decodeURIComponent(window.location.hash.replace(/^#/, '')); }
    catch (error) { return ''; }
  };

  const showStage = id => {
    const next = valid.has(id) ? id : active;
    stages.forEach(stage => stage.classList.toggle('is-active', stage.dataset.slshopStage === next));
  };

  const syncBookSubnav = () => {
    const key = safeHash();
    const current = ['collections-livres', 'je-decouvre', 'mon-roi-ma-reine'].indexOf(key) >= 0 ? key : 'collections-livres';
    bookSubnavLinks.forEach(link => {
      const on = link.getAttribute('href') === '#' + current;
      link.classList.toggle('is-active', on);
      if (on) link.setAttribute('aria-current', 'location'); else link.removeAttribute('aria-current');
    });
  };

  const setRayon = (id, options) => {
    const next = valid.has(id) ? id : 'livres';
    const opts = options || {};
    active = next;
    panels.forEach(panel => panel.classList.toggle('is-active', panel.dataset.slshopPanel === next));
    entries.forEach(link => {
      const on = link.dataset.slshopEntry === next;
      link.classList.toggle('is-active', on);
      if (on) link.setAttribute('aria-current', 'true'); else link.removeAttribute('aria-current');
    });
    navLinks.forEach(link => {
      const on = link.dataset.slshopNavLink === next;
      link.classList.toggle('is-active', on);
      if (on) link.setAttribute('aria-current', 'location'); else link.removeAttribute('aria-current');
    });
    syncBookSubnav();
    showStage(next);
    if (opts.updateHash && window.location.hash !== '#' + next) {
      history.pushState(null, '', '#' + next);
      window.dispatchEvent(new Event('hashchange'));
    }
    if (opts.scroll) {
      const target = panels.find(panel => panel.dataset.slshopPanel === next);
      if (target) window.setTimeout(() => target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' }), 0);
    }
  };

  const categoryFromHash = () => {
    const key = safeHash();
    return hashMap[key] || 'livres';
  };

  entries.forEach(link => {
    const id = link.dataset.slshopEntry;
    link.addEventListener('mouseenter', () => showStage(id));
    link.addEventListener('focus', () => showStage(id));
    link.addEventListener('mouseleave', () => showStage(active));
    link.addEventListener('click', e => { e.preventDefault(); setRayon(id, { updateHash: true, scroll: true }); });
  });
  navLinks.forEach(link => link.addEventListener('click', e => {
    e.preventDefault();
    setRayon(link.dataset.slshopNavLink, { updateHash: true, scroll: true });
  }));
  window.addEventListener('hashchange', () => setRayon(categoryFromHash(), { scroll: false }));
  setRayon(categoryFromHash(), { scroll: false });
  if ('IntersectionObserver' in window) {
    const chapterSpy = new IntersectionObserver(items => {
      items.forEach(item => {
        if (item.isIntersecting) setRayon(item.target.dataset.slshopPanel, { scroll: false });
      });
    }, { rootMargin: '-30% 0px -62% 0px', threshold: 0 });
    panels.forEach(panel => chapterSpy.observe(panel));
  }
})();

/* Boutique, choix guidé : deux packs pertinents plutôt que six offres empilées */
(function () {
  const section = document.querySelector('.shop-packs');
  if (!section) return;
  const controls = Array.from(section.querySelectorAll('[data-pack-filter]'));
  const cards = Array.from(section.querySelectorAll('[data-pack-kind]'));
  const grid = section.querySelector('[data-pack-grid]');
  const status = section.querySelector('.shop-pack-status');
  const messages = {
    complete: "2 packs pour découvrir tout l'univers",
    books: '2 coffrets pour les lecteurs',
    games: '2 packs pour jouer en famille',
    all: 'Les 6 nouveaux packs Saint-Louis'
  };

  const apply = filter => {
    const next = messages[filter] ? filter : 'complete';
    controls.forEach(control => {
      const active = control.dataset.packFilter === next;
      control.classList.toggle('is-active', active);
      control.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    let visible = 0;
    cards.forEach(card => {
      const show = next === 'all' || card.dataset.packKind === next;
      card.hidden = !show;
      if (show) visible += 1;
    });
    if (grid) grid.classList.toggle('is-pair', visible === 2);
    if (status) status.textContent = messages[next];
  };

  controls.forEach(control => control.addEventListener('click', () => apply(control.dataset.packFilter)));
  apply('complete');
})();

/* Boutique, la navigation de familles indique toujours la zone en cours */
(function () {
  const nav = document.querySelector('[data-shop-family-nav]');
  if (!nav) return;
  const links = Array.from(nav.querySelectorAll('[data-shop-family]'));
  const track = nav.querySelector('.shop-family-nav__in');
  const sections = links.map(link => document.getElementById(link.dataset.shopFamily)).filter(Boolean);
  let current = null;
  const activate = id => {
    let activeLink = null;
    links.forEach(link => {
      const active = link.dataset.shopFamily === id;
      link.classList.toggle('is-active', active);
      if (active) { link.setAttribute('aria-current', 'location'); activeLink = link; }
      else link.removeAttribute('aria-current');
    });
    if (activeLink && current !== id && track && track.scrollWidth > track.clientWidth) {
      const left = activeLink.offsetLeft - (track.clientWidth - activeLink.offsetWidth) / 2;
      track.scrollTo({ left: Math.max(0, left), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    current = id;
  };
  links.forEach(link => link.addEventListener('click', () => activate(link.dataset.shopFamily)));
  if ('IntersectionObserver' in window) {
    const spy = new IntersectionObserver(entries => {
      entries.forEach(entry => { if (entry.isIntersecting) activate(entry.target.id); });
    }, { rootMargin: '-28% 0px -62% 0px', threshold: 0 });
    sections.forEach(section => spy.observe(section));
  }
})();

/* Fiches produit, le rappel déjà présent parle le même langage que le hub */
(function () {
  document.querySelectorAll('.pdp-upsell').forEach(upsell => {
    const button = upsell.querySelector('.add');
    if (button) button.textContent = 'Profiter du pack';
  });
})();

/* Boutique Maison vivante, vestiaire filtré sans recréer les cartes ni casser le panier AJAX */
(function () {
  const wardrobe = document.querySelector('.shop-wardrobe');
  if (!wardrobe) return;
  const controls = Array.from(wardrobe.querySelectorAll('[data-wardrobe-filter]'));
  const cards = Array.from(wardrobe.querySelectorAll('[data-wardrobe-kind]'));
  const allowed = new Set(['all'].concat(cards.map(card => card.dataset.wardrobeKind)));

  const applyFilter = filter => {
    const next = allowed.has(filter) ? filter : 'all';
    controls.forEach(control => {
      const active = control.dataset.wardrobeFilter === next;
      control.classList.toggle('is-active', active);
      control.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    cards.forEach(card => { card.hidden = next !== 'all' && card.dataset.wardrobeKind !== next; });
  };

  controls.forEach(control => control.addEventListener('click', () => {
    applyFilter(control.dataset.wardrobeFilter);
    const nextHash = control.id ? '#' + control.id : '#vetements';
    if (window.location.hash !== nextHash) history.replaceState(null, '', nextHash);
  }));

  const filterFromHash = () => {
    const hashFilters = { '#hoodies': 'hoodie', '#sweats': 'sweat', '#tshirts': 'tshirt', '#tous-vetements': 'all', '#vetements': 'all' };
    if (!hashFilters[window.location.hash]) return false;
    applyFilter(hashFilters[window.location.hash]);
    return true;
  };
  if (!filterFromHash()) applyFilter(controls.some(control => control.dataset.wardrobeFilter === 'tshirt') ? 'tshirt' : (controls[0] ? controls[0].dataset.wardrobeFilter : 'all'));
  window.addEventListener('hashchange', filterFromHash);
})();

/* Sous-catégories Jeux et Affiches, filtrage instantané, sans rechargement */
(function () {
  const groups = Array.from(document.querySelectorAll('[data-shop-filter-group]'));
  if (!groups.length) return;

  const apply = (group, filter) => {
    const section = group.closest('.shop-catalogue');
    if (!section) return;
    const controls = Array.from(group.querySelectorAll('[data-shop-filter]'));
    const cards = Array.from(section.querySelectorAll('[data-shop-kind]'));
    const offers = Array.from(section.querySelectorAll('[data-visible-for]'));
    let status = section.querySelector('[data-shop-filter-status]');
    if (!status) {
      status = document.createElement('p');
      status.className = 'sr-only';
      status.dataset.shopFilterStatus = '';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      group.insertAdjacentElement('afterend', status);
    }
    controls.forEach(control => {
      const active = control.dataset.shopFilter === filter;
      control.classList.toggle('is-active', active);
      control.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    cards.forEach(card => { card.hidden = filter !== 'all' && card.dataset.shopKind !== filter; });
    offers.forEach(offer => {
      const visibleFor = (offer.dataset.visibleFor || '').split(/\s+/);
      offer.hidden = visibleFor.indexOf(filter) < 0;
    });
    section.querySelectorAll('[data-gift-secondary]').forEach(element => {
      element.hidden = filter === 'ensemble';
    });
    const activeControl = controls.find(control => control.dataset.shopFilter === filter);
    const visibleCount = cards.filter(card => !card.hidden).length;
    const filterName = activeControl ? activeControl.textContent.replace(/\s+/g, ' ').trim() : 'Tous';
    status.textContent = visibleCount + ' offre' + (visibleCount > 1 ? 's' : '') + ' affichée' + (visibleCount > 1 ? 's' : '') + ', ' + filterName;
  };

  groups.forEach(group => {
    const section = group.closest('.shop-catalogue');
    group.querySelectorAll('[data-shop-filter]').forEach(control => {
      control.addEventListener('click', () => {
        apply(group, control.dataset.shopFilter);
        const nextHash = control.id ? '#' + control.id : (section && section.id ? '#' + section.id : '');
        if (nextHash && window.location.hash !== nextHash) history.replaceState(null, '', nextHash);
      });
    });
    const initial = group.querySelector('[data-shop-filter].is-active') || group.querySelector('[data-shop-filter]');
    if (initial) apply(group, initial.dataset.shopFilter);
  });

  const filterFromHash = () => {
    if (!window.location.hash || window.location.hash === '#') return;
    const mapped = {
      '#jeux': ['jeux', 'all'],
      '#cadeaux': ['cadeaux', 'all'],
      '#grands-cadeaux': ['cadeaux', 'ensemble']
    }[window.location.hash];
    if (mapped) {
      const group = groups.find(item => item.dataset.shopFilterGroup === mapped[0]);
      if (group) apply(group, mapped[1]);
      return;
    }
    let target = null;
    try { target = document.querySelector(window.location.hash); } catch (e) { return; }
    if (target && target.matches('[data-shop-filter]')) target.click();
  };
  filterFromHash();
  window.addEventListener('hashchange', filterFromHash);
})();

/* Hero, enchaînement des héros animés (caméra fixe, crossfade toutes les ~5 s) */
(function () {
  const vids = Array.from(document.querySelectorAll('.vhero .vhv'));
  if (vids.length < 2) return;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reducedMotion) {
    vids.forEach(video => { video.removeAttribute('autoplay'); video.pause(); });
    return;
  }
  let cur = 0;
  let heroVisible = true;
  const load = i => { const v = vids[i]; if (v && !v.getAttribute('src') && v.dataset.src) { v.src = v.dataset.src; v.load(); } };
  const canPlay = () => heroVisible && !document.hidden;
  const playV = v => { if (!v || !canPlay()) return; const p = v.play(); if (p && p.catch) p.catch(() => {}); };
  playV(vids[cur]);
  load(1);
  setInterval(() => {
    if (!canPlay()) return;
    const nxt = (cur + 1) % vids.length;
    load(nxt);
    const v = vids[nxt];
    try { v.currentTime = 0; } catch (e) {}
    playV(v);
    const sortante = vids[cur];
    sortante.classList.remove('active');
    v.classList.add('active');
    cur = nxt;
    setTimeout(() => { if (sortante !== vids[cur]) sortante.pause(); }, 1300);
    load((nxt + 1) % vids.length);
  }, 5200);
  // Économie : pause hors viewport, reprise de l'active seule
  const hero = document.querySelector('.vhero');
  if (hero && 'IntersectionObserver' in window) {
    new IntersectionObserver(es => {
      es.forEach(e => {
        heroVisible = e.isIntersecting;
        if (heroVisible) playV(vids[cur]);
        else vids.forEach(v => v.pause());
      });
    }).observe(hero);
  }
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) vids.forEach(v => v.pause());
    else if (heroVisible) playV(vids[cur]);
  });
})();

/* ===== PANIER SHOPIFY (AJAX) + tiroir injecté sur toutes les pages ===== */
window.ESLCART = (function () {
  const fmt = c => (c / 100).toFixed(2).replace('.', ',') + ' €';
  const esc = value => String(value == null ? '' : value).replace(/[&<>"']/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char]);
  // Franco en centimes : lu depuis le reglage de theme esl_franco (theme.liquid -> window.ESL_FRANCO), jamais en dur ici.
  const FREE_SHIP = (window.ESL_FRANCO > 0 ? window.ESL_FRANCO : 4500);
  const francoTxt = () => fmt(FREE_SHIP).replace(',00', '');
  // Au-dela de cet ecart, aucun article seul ne comble la marche : on se tait.
  // 26/09/2026, Edwin : plus de frais de livraison juste avant le paiement, « offert des 40 EUR »
  // suffit. La relance ne s'affiche plus ; remettre 2000 pour la rallumer.
  const RELANCE_MAX = 0;

  // 26/09/2026, Edwin : la citation de Péguy au-dessus du bouton, en écriture manuscrite.
  if (!document.getElementById('esl-citation-style')) {
    const lp = document.createElement('link'); lp.rel = 'stylesheet'; lp.href = 'https://fonts.googleapis.com/css2?family=Dancing+Script:wght@500&display=swap';
    document.head.appendChild(lp);
    const sc = document.createElement('style'); sc.id = 'esl-citation-style';
    sc.textContent = '.cart-citation{margin:.1rem 0 .7rem;padding:.55rem .6rem .5rem;text-align:center;border-top:1px solid #b8893a;border-bottom:1px solid #b8893a;background:linear-gradient(180deg,rgba(184,137,58,.10),rgba(184,137,58,.03))}.cart-citation__orn{display:block;font-family:"Cinzel",Georgia,serif;color:#7a5519;font-size:.62rem;letter-spacing:.5em;margin-bottom:.1rem}.cart-citation__q{margin:0;font-family:"Dancing Script",cursive;font-weight:500;font-size:1.28rem;line-height:1.22;color:#1b2146}.cart-citation__a{display:block;margin-top:.3rem;font-family:"Cinzel",Georgia,serif;font-weight:600;font-size:.64rem;letter-spacing:.16em;color:#7a5519}.cart-citation__m{display:block;margin-top:.3rem;font-family:Montserrat,system-ui,sans-serif;font-size:.8rem;line-height:1.4;color:#2c3355}@media (min-width:750px){.cart-citation__q{font-size:1.42rem}.cart-citation__m{font-size:.85rem}}.cart-upg[hidden]{display:none!important}.cart-cplt{margin:14px 0 0;border-top:1px solid #d9c391;padding-top:14px}.cart-cplt h3{font-size:1rem;line-height:1.3;margin:0 0 10px;color:#14263e}.cart-cplt .cart-relance__it[disabled]{opacity:.6;cursor:wait}';
    document.head.appendChild(sc);
  }
  const ov = document.createElement('div'); ov.className = 'cart-overlay';
  const dr = document.createElement('aside'); dr.className = 'cart-drawer';
  dr.setAttribute('role', 'dialog'); dr.setAttribute('aria-modal', 'true'); dr.setAttribute('aria-labelledby', 'cartDrawerTitle'); dr.setAttribute('aria-hidden', 'true'); dr.setAttribute('aria-busy', 'false'); dr.tabIndex = -1;
  dr.innerHTML = '<div class="cart-drawer__head"><h3 id="cartDrawerTitle">Mon panier</h3><button class="cart-drawer__close" type="button" aria-label="Fermer le panier">×</button></div>' +
    '<div class="cart-scroll"><div class="cart-lines" aria-live="polite"></div>' +
    /* 17/09 lot 2 : tout ce qui n'est pas Total + Commander defile avec les lignes ; le pied reste toujours visible */
    '<div class="cart-extra">' +
      '<div class="cart-upg" hidden></div>' +
      '<div class="cart-ship" style="display:none"><div class="cart-ship__bar"><i></i></div><p class="cart-ship__txt" aria-live="polite" aria-atomic="true"></p></div>' +
      '<p class="cart-points"></p>' +
      '<div class="cart-trust"><span><i class="crest" aria-hidden="true"></i> Paiement sécurisé</span><span><i class="crest" aria-hidden="true"></i> Retour 14&nbsp;j</span><span><i class="crest" aria-hidden="true"></i> Dès ' + francoTxt().replace(' ', '&nbsp;') + ' offert</span></div>' +
      '<p class="drawer__ship" hidden></p>' +
      '<p class="drawer__relais">&#128205; <b>Livraison en point relais Mondial Relay</b>, partout en France.</p>' +
      '<div class="cart-bons" hidden></div>' +
      '<div class="cart-relance" hidden></div>' +
      '<a href="/cart" class="cart-see">ou revoir mon panier en détail</a>' +
      '<small class="cart-gift">&#127873; Avec votre commande&nbsp;: <a href="/pages/telechargement" style="color:inherit;text-decoration:underline">coloriages et marque-pages des h&eacute;ros</a> &agrave; imprimer, offerts.</small>' +
    '</div></div>' +
    '<div class="cart-foot">' +
      '<div class="cart-foot__row"><span>Total</span><span class="cart-total" aria-live="polite" aria-atomic="true">0,00 €</span></div>' +
      '<div class="cart-mission cart-citation"><span class="cart-citation__orn" aria-hidden="true">&#10022;</span><p class="cart-citation__q">&laquo;&nbsp;Une société qui n&rsquo;enseigne pas est une société qui ne s&rsquo;aime pas.&nbsp;&raquo;</p><span class="cart-citation__a">Charles Péguy</span><span class="cart-citation__m">Merci de transmettre la France avec nous.</span></div>' +
      '<div class="cart-acts">' +
        '<a href="/checkout" class="btn btn--gold cart-go">Commander &rarr;</a>' +
        '<button type="button" class="btn btn--ghost cart-keep">Continuer mes achats</button>' +
      '</div>' +
      '<small class="cart-rassure">Vous validez tout avant le paiement&nbsp;: rien n&rsquo;est débité sans votre confirmation.</small>' +
    '</div>';
  document.body.appendChild(ov); document.body.appendChild(dr);
  let dansLePanier = [], titresDuPanier = [], handlesDuPanier = [];
  const linesEl = dr.querySelector('.cart-lines');
  const totalEl = dr.querySelector('.cart-total');
  const countEl = document.getElementById('cartCount');
  const shipTxt = dr.querySelector('.cart-ship__txt');
  const shipBar = dr.querySelector('.cart-ship__bar i');
  const ptsEl = dr.querySelector('.cart-points');
  const shipMsgEl = dr.querySelector('.drawer__ship');
  let busy = false;
  let lastFocus = null;
  let inertedByCart = [];

  function setCartBackgroundInert(open) {
    if (open) {
      inertedByCart = Array.from(document.body.children).filter(element => element !== ov && element !== dr && !element.inert);
      inertedByCart.forEach(element => { element.inert = true; });
    } else {
      inertedByCart.forEach(element => { element.inert = false; });
      inertedByCart = [];
    }
  }

  function showCartError(message) {
    const note = document.createElement('p');
    note.className = 'cart-error';
    note.setAttribute('role', 'alert');
    note.textContent = message || "Le panier n'a pas pu être mis à jour. Veuillez réessayer.";
    linesEl.prepend(note);
    window.setTimeout(() => note.remove(), 6000);
    open();
  }

  function render(cart) {
    const items = (cart && cart.items) || [];
    if (!items.length) linesEl.innerHTML = '<p class="cart-empty">Votre panier est vide.</p>';
    else linesEl.innerHTML = items.map(it => {
      const variant = it.variant_title && it.variant_title !== 'Default Title' ? '<small class="cart-line__variant">' + esc(it.variant_title) + '</small>' : '';
      const properties = Object.entries(it.properties || {}).filter(([name, value]) => name.charAt(0) !== '_' && value).map(([name, value]) => '<small class="cart-line__variant">' + esc(name) + '&nbsp;: ' + esc(value) + '</small>').join('');
      const key = esc(it.key);
      const title = esc(it.product_title);
      const url = esc(it.url || '/cart');
      const imageUrl = it.image ? it.image + (it.image.indexOf('?') >= 0 ? '&' : '?') + 'width=144' : '';
      const image = imageUrl ? '<a class="cart-line__image" href="' + url + '" aria-label="Voir ' + title + '"><img loading="lazy" decoding="async" src="' + esc(imageUrl) + '" width="72" height="72" alt=""></a>' : '';
      return '<div class="cart-line' + (image ? '' : ' cart-line--noimage') + '">' + image + '<div class="cart-line__main"><div class="cart-line__t"><a class="cart-line__title" href="' + url + '">' + title + '</a>' + variant + properties + '<span>' + fmt(it.final_line_price) + '</span></div><div class="cart-line__acts"><span class="cart-qty"><button class="cart-qty__btn" type="button" data-key="' + key + '" data-q="' + (it.quantity - 1) + '" aria-label="Diminuer la quantité de ' + title + '">−</button><b>' + it.quantity + '</b><button class="cart-qty__btn" type="button" data-key="' + key + '" data-q="' + (it.quantity + 1) + '" aria-label="Augmenter la quantité de ' + title + '">+</button></span><button class="cart-line__rm" type="button" data-key="' + key + '" data-q="0" aria-label="Retirer ' + title + ' du panier">Retirer</button></div></div></div>';
    }).join('');
    if (items.length) { const cplt = complementsHtml(items, (cart && cart.total_price) || 0); if (cplt) linesEl.insertAdjacentHTML('beforeend', cplt); }
    const total = (cart && cart.total_price) || 0;
    totalEl.textContent = fmt(total);
    const itemCount = (cart && cart.item_count) || 0;
    if (countEl) countEl.textContent = itemCount;
    const cartButton = document.getElementById('cartBtn');
    if (cartButton) cartButton.setAttribute('aria-label', itemCount ? 'Panier, ' + itemCount + ' article' + (itemCount > 1 ? 's' : '') : 'Panier vide');
    // parcours d'achat : la voie rapide ne s'affiche que si le panier contient qqch
    const empty = !items.length;
    dr.querySelectorAll('.cart-acts, .cart-go, .cart-see, .cart-trust, .cart-rassure, .cart-mission').forEach(el => { el.style.display = empty ? 'none' : ''; });
    if (shipTxt && shipBar) {
      if (total >= FREE_SHIP) { shipTxt.innerHTML = '&#10003; <b>Livraison en point relais</b> offerte&nbsp;!'; shipBar.style.width = '100%'; }
      else if (total > 0) { shipTxt.innerHTML = 'Plus que <b>' + fmt(FREE_SHIP - total) + '</b> pour la livraison offerte en point relais'; shipBar.style.width = (total / FREE_SHIP * 100) + '%'; }
      else { shipTxt.textContent = 'Livraison offerte dès ' + francoTxt() + ' en point relais'; shipBar.style.width = '0%'; }
    }
    // Delai d'expedition : le texte vient de Liquid, jamais du JavaScript, sinon il se fige.
    // Sans cette valeur on prefere ne rien annoncer plutot qu'annoncer une date fausse.
    if (shipMsgEl) {
      const liv = window.ESL_LIVRAISON;
      if (!liv || !liv.normal) { shipMsgEl.hidden = true; }
      else {
        const precoIds = liv.precoIds || [];
        const enReassort = items.some(it => precoIds.indexOf(it.product_id) >= 0);
        const avecClovis = items.some(it => (window.ESL_CLOVIS_VARIANTS || []).some(id => String(id) === String(it.variant_id || it.id)));
        // 26/09/2026, Edwin : le message ordinaire (« Préparé à la main, suivi fourni ») ne s'affiche plus.
        // Restent les avis de délai exceptionnels : Clovis, précommande, ateliers fermés.
        const ordinaire = /Vous recevez le num/.test(liv.normal);
        const avecDec = items.some(it => (window.ESL_DEC_VARIANTS || []).some(id => String(id) === String(it.variant_id || it.id)));
        const avecNov = items.some(it => (window.ESL_NOV_VARIANTS || []).some(id => String(id) === String(it.variant_id || it.id)));
        const avecNoel = items.some(it => (window.ESL_NOEL_VARIANTS || []).some(id => String(id) === String(it.variant_id || it.id)));
        const msgExp = avecNoel && window.ESL_NOEL_AVIS ? window.ESL_NOEL_AVIS : avecDec && window.ESL_DEC_AVIS ? window.ESL_DEC_AVIS : avecNov && window.ESL_NOV_AVIS ? window.ESL_NOV_AVIS : (enReassort && liv.preco ? liv.preco : (ordinaire ? '' : liv.normal));
        shipMsgEl.innerHTML = msgExp;
        shipMsgEl.hidden = !msgExp;
      }
    }
    if (ptsEl) {
      const p = Math.floor(total / 100);
      let msg = p > 0 ? '<i class="crest" aria-hidden="true"></i> Cet achat vous rapporte <b>' + p + ' points</b> du Cercle' : '';
      // Rangs du Cercle (canon Quête des Héros) : le panier annonce le passage de rang
      const LV = [['Page',0],['Écuyer',15],['Chevalier',45],['Capitaine',100],['Seigneur',200],['Duc',350],['Roi',550],['Empereur',850]];
      const lvIdx = pts => { let i = 0; LV.forEach((l, k) => { if (pts >= l[1]) i = k; }); return i; };
      const cu = window.ESL_CUST;
      if (p > 0 && cu && cu.points != null) {
        const before = lvIdx(cu.points), after = lvIdx(cu.points + p);
        if (after > before) msg += ', 🎉 elle vous fait passer au rang de <b>' + LV[after][0] + '</b> !';
        else if (after < 7) {
          const need = LV[after + 1][1] - (cu.points + p);
          msg += ', plus que <b>' + need + '</b> avant le rang <b>' + LV[after + 1][0] + '</b>.';
        }
      } else if (p > 0 && !cu) {
        msg += ' · <a href="/pages/mon-espace" style="color:inherit;text-decoration:underline">créez votre compte</a> pour les garder';
      }
      ptsEl.innerHTML = msg;
    }
    dernierTotal = total;
    // 11/10/2026 : le pack qui contient déjà ce qui est dans le panier, avec ce qu'il coûte de plus
    const upgEl = dr.querySelector('.cart-upg');
    if (upgEl) { const o = window.eslPackOffre ? window.eslPackOffre(cart) : null; upgEl._o = o; upgEl.hidden = !o; upgEl.innerHTML = o ? window.eslPackHtml(o) : ''; }
    dansLePanier = items.map(it => String(it.variant_id || it.id));
    titresDuPanier = items.map(it => (it.product_title || it.title || '').toLowerCase());
    handlesDuPanier = items.map(it => it.handle || '');
    // Proposer l'article qui fait franchir la marche du franco. Branche le 18/09/2026 : la fonction
    // existait depuis le debut et n'etait jamais appelee, le bloc ne s'affichait donc jamais.
    // On ne relance que si la marche est franchissable par un seul article, sinon c'est du bruit.
    if (relance) {
      const manque = FREE_SHIP - total;
      if (!relanceVue && total > 0 && manque > 0 && manque <= RELANCE_MAX) montrerRelance(manque);
      else relance.hidden = true;
    }
    if (typeof majBarre === 'function') majBarre(total, itemCount);
    document.querySelectorAll('[data-cart-total]').forEach(e => e.textContent = fmt(total));
    document.dispatchEvent(new CustomEvent('cart:change', { detail: cart }));
  }
  function refresh() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(response => { if (!response.ok) throw new Error('Cart refresh failed'); return response.json(); })
      .then(cart => { render(cart); return cart; })
      .catch(() => null);
  }
  function change(key, qty, source) {
    if (busy) return; busy = true;
    dr.setAttribute('aria-busy', 'true');
    const actionText = source ? source.textContent.trim() : '';
    const restoreCartFocus = () => window.requestAnimationFrame(() => {
      const sameAction = Array.from(dr.querySelectorAll('[data-key]')).find(control => control.dataset.key === key && control.textContent.trim() === actionText);
      (sameAction || dr.querySelector('.cart-drawer__close')).focus();
    });
    dr.classList.add('is-busy');
    dr.querySelectorAll('.cart-qty__btn').forEach(b => { b.disabled = true; });
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(r => r.json().then(j => ({ ok: r.ok, j })))
      .then(({ ok, j }) => {
        if (ok) { render(j); restoreCartFocus(); return; }
        return refresh().then(() => { showCartError((j && (j.description || j.message)) || "Cette quantité n'est pas disponible."); restoreCartFocus(); });
      })
      .catch(() => refresh().then(() => { showCartError(); restoreCartFocus(); }))
      .then(() => {
        busy = false;
        dr.setAttribute('aria-busy', 'false');
        dr.classList.remove('is-busy');
        dr.querySelectorAll('.cart-qty__btn').forEach(b => { b.disabled = false; });
      });
  }
  function add(variantId, qty, properties, sellingPlan) {
    if (busy || !variantId) return Promise.resolve(false); busy = true;
    dr.setAttribute('aria-busy', 'true');
    const item = { id: variantId, quantity: qty || 1 };
    if ((window.ESL_DEC_VARIANTS || []).some(id => String(id) === String(variantId))) properties = Object.assign({}, properties, {'Livraison': window.ESL_DEC_TXT});
    if ((window.ESL_NOEL_VARIANTS || []).some(id => String(id) === String(variantId))) properties = Object.assign({}, properties, {'Livraison': window.ESL_NOEL_TXT});
    if ((window.ESL_NOV_VARIANTS || []).some(id => String(id) === String(variantId))) properties = Object.assign({}, properties, {'Expédition': window.ESL_NOV_TXT});
    if (properties && Object.keys(properties).length) item.properties = properties;
    if (sellingPlan) item.selling_plan = sellingPlan;
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [item] }) })
      .then(r => r.json().then(j => ({ ok: r.ok, j })))
      .then(({ ok, j }) => {
        if (!ok) {
          return refresh().then(() => {
            showCartError((j && (j.description || j.message)) || "Cet article n'est pas disponible pour le moment.");
            return false;
          });
        }
        return refresh().then(() => { open(); return true; });
      })
      .catch(() => refresh().then(() => { showCartError(); return false; }))
      .then(ok => { busy = false; dr.setAttribute('aria-busy', 'false'); return ok; });
  }
  // ---- relance « il vous manque X € pour la livraison offerte » ----
  const relance = dr.querySelector('.cart-relance');
  const keepBtn = dr.querySelector('.cart-keep');
  let dernierTotal = 0, relanceVue = false;

  // les héros déjà dans le panier, pour départager à prix voisin
  const HEROS = ['clovis', 'clotilde', 'aliénor', 'alienor', 'françois', 'francois',
                 'jeanne', 'napoléon', 'napoleon', 'saint louis'];
  function suggestions(manque) {
    const dedans = new Set(dansLePanier);
    // Decision d'Edwin du 18/09/2026 : l'article qui complete la marche est un Mon Roi Ma Reine.
    // Le Pack Mon Roi Ma Reine contient deja les cinq titres, et il lui manque 3,05 EUR pour le franco :
    // rien d'autre au catalogue ne coute assez peu. On accepte donc l'exemplaire en double, qui se donne.
    const packMrmrDedans = handlesDuPanier.indexOf('coffret-mon-roi-ma-reine-5') >= 0;
    const packCatalog = window.ESL_PACKS || [];
    const occupied = new Set(handlesDuPanier.flatMap(h => { const p = packCatalog.find(p => p.h === h); return p ? p.parts : [h]; }));
    const l = (window.ESL_SUGG || []).filter(x => x && x.v && !dedans.has(String(x.v)) &&
      (!occupied.has(x.h) || (packMrmrDedans && x.mrmr)) &&
      !packCatalog.some(p => p.h === x.h && p.parts.some(h => occupied.has(h))) &&
      !titresDuPanier.some(t => t && (x.t || '').toLowerCase() === t));
    const fratrie = window.ESL_FRATRIE;
    if (packMrmrDedans && fratrie && fratrie.v && !dedans.has(String(fratrie.v))) {
      const autre = l.filter(x => x.p >= manque && x.h !== 'pack-fratrie').sort((a, b) => a.p - b.p).slice(0, 1);
      return [fratrie].concat(autre);
    }
    if (!l.length) return [];
    const miens = HEROS.filter(h => titresDuPanier.join(' ').indexOf(h) >= 0);
    const parle = x => miens.some(h => (x.t || '').toLowerCase().indexOf(h) >= 0);
    // ceux qui suffisent, du moins cher au plus cher : on complète le panier,
    // on ne le remplace pas. À moins de 3 € d'écart, le héros déjà choisi passe devant.
    const pile = l.filter(x => x.p >= manque).sort((a, b) =>
      (Math.abs(a.p - b.p) < 300 ? (parle(b) ? 1 : 0) - (parle(a) ? 1 : 0) : 0) || (a.p - b.p));
    const tete = pile.slice(0, 2);
    // en secours, ce qui approche le plus de la barre sans l'atteindre
    const reste = l.filter(x => x.p < manque && !tete.includes(x)).sort((a, b) => b.p - a.p);
    return tete.concat(reste.slice(0, 2 - tete.length));
  }

  // 31/10/2026, Edwin : « ajouter des éléments pour compléter le panier ». Trois articles à ajouter d'un geste,
  // choisis d'après le panier : le même héros d'abord, puis les petits compléments (25 EUR au plus, jamais un vêtement
  // d'un autre héros), ce qui fait passer la livraison offerte avant le reste, du moins cher au plus cher.
  // Jamais un pack (le bloc des packs s'en charge), ni l'abonnement, ni la carte cadeau, ni un article dont la date
  // d'envoi diffère de celle du panier (il retarderait toute la commande).
  const CPLT_EXCLUS = ['journal-louise-et-joseph', 'carte-cadeau-saint-louis'];
  function complements(items, total) {
    if (items.some(it => it.selling_plan_allocation)) return [];
    const ids = new Set(items.map(it => String(it.variant_id || it.id)));
    const sansAccent = s => (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
    const titres = items.map(it => (it.product_title || '').toLowerCase());
    const packs = window.ESL_PACKS || [];
    const pris = new Set(items.map(it => it.handle || '').flatMap(h => { const p = packs.find(q => q.h === h); return p ? p.parts : [h]; }));
    const listes = [window.ESL_NOEL_VARIANTS, window.ESL_DEC_VARIANTS, window.ESL_NOV_VARIANTS, window.ESL_CLOVIS_VARIANTS].map(l => (l || []).map(String));
    const classe = v => listes.findIndex(l => l.indexOf(String(v)) >= 0);
    const classesPanier = new Set(items.map(it => classe(it.variant_id || it.id)));
    const heros = ['clovis', 'clotilde', 'alienor', 'francois', 'jeanne', 'napoleon', 'saint louis', 'hugast'];
    const miens = heros.filter(h => sansAccent(titres.join(' ')).indexOf(h) >= 0);
    const parle = x => miens.some(h => sansAccent(x.t).indexOf(h) >= 0);
    const manque = FREE_SHIP - total;
    const l = (window.ESL_SUGG || []).filter(x => x && x.v && !ids.has(String(x.v)) && !pris.has(x.h) &&
      CPLT_EXCLUS.indexOf(x.h) < 0 && !packs.some(p => p.h === x.h) &&
      !titres.some(t => t && (x.t || '').toLowerCase() === t) &&
      (classe(x.v) < 0 || classesPanier.has(classe(x.v))) &&
      (parle(x) || (!x.m && x.p <= 2500)));   // un autre héros : seulement un petit complément, jamais un vêtement
    const rang = x => (parle(x) ? 0 : 2) + (manque > 0 && x.p >= manque ? 0 : 1);
    // un seul article par famille (un Mon Roi Ma Reine, un Éventail, un puzzle…), sauf pour le même héros
    const famille = x => { const t = (x.t || '').toLowerCase();
      return t.indexOf('mon roi ma reine') === 0 ? 'mrmr' : t.indexOf('éventail') >= 0 ? 'eventail' : t.indexOf('puzzle') >= 0 ? 'puzzle'
        : t.indexOf('t-shirt') === 0 ? 'tshirt' : t.indexOf('je découvre') === 0 ? 'jd' : x.h; };
    const choisis = [], vues = new Set();
    l.sort((a, b) => rang(a) - rang(b) || a.p - b.p).forEach(x => {
      if (choisis.length >= 3) return;
      const f = famille(x); if (vues.has(f) && !parle(x)) return;
      vues.add(f); choisis.push(x);
    });
    return choisis;
  }
  function complementsHtml(items, total) {
    const l = complements(items, total);
    if (!l.length) return '';
    const manque = FREE_SHIP - total;
    return '<section class="cart-cplt"><h3>Pour compléter votre panier</h3><div class="cart-relance__list">' + l.map(x =>
      (x.m ? '<a class="cart-relance__it" href="' + esc(x.u) + '">'
           : '<button type="button" class="cart-relance__it" data-cplt="' + x.v + '" aria-label="Ajouter ' + esc(x.t) + ' au panier">') +
      (x.i ? '<img loading="lazy" decoding="async" src="' + esc(x.i) + '" alt="" width="44" height="44">' : '') +
      '<span><b>' + esc(x.t) + '</b><small>' + fmt(x.p) + (manque > 0 && x.p >= manque ? ' · livraison offerte' : '') +
      (x.m ? ' · choisir la taille' : '') + '</small></span>' +
      '<i aria-hidden="true">' + (x.m ? '→' : '+') + '</i>' + (x.m ? '</a>' : '</button>')).join('') + '</div></section>';
  }

  function montrerRelance(manque) {
    const items = suggestions(manque);
    if (!items.length) { relance.hidden = true; return false; }
    relance.innerHTML =
      '<p class="cart-relance__t">Il vous manque <b>' + fmt(manque) + '</b> pour la <b>livraison offerte</b> en point relais.' +
      '<button type="button" class="cart-relance__skip">Commander sans &rarr;</button></p>' +
      '<div class="cart-relance__list">' + items.map(x =>
        (x.m
          ? '<a class="cart-relance__it" href="' + esc(x.u) + '">'
          : '<button type="button" class="cart-relance__it" data-sugg="' + x.v + '">') +
        (x.i ? '<img loading="lazy" decoding="async" src="' + esc(x.i) + '" alt="" width="44" height="44">' : '') +
        '<span><b>' + esc(x.t) + '</b><small>' + fmt(x.p) + (x.p >= manque ? ' · livraison offerte' : '') + (x.m ? ' · choisir la taille' : '') + '</small></span>' +
        '<i aria-hidden="true">' + (x.m ? '→' : '+') + '</i>' + (x.m ? '</a>' : '</button>')).join('') + '</div>' +
      '<button type="button" class="cart-relance__no">Non merci, je commande maintenant &rarr;</button>';
    relance.hidden = false;
    // sans ça, sur un petit écran, les suggestions poussent le bouton de refus hors de vue
    const sortie = relance.querySelector('.cart-relance__no');
    if (sortie && sortie.scrollIntoView) {
      window.requestAnimationFrame(() => sortie.scrollIntoView({ block: 'nearest' }));
    }
    return true;
  }

  if (relance) {
    relance.addEventListener('click', e => {
      const it = e.target.closest('[data-sugg]');
      if (it) { add(parseInt(it.dataset.sugg, 10), 1); relance.hidden = true; return; }
      if (e.target.closest('.cart-relance__no') || e.target.closest('.cart-relance__skip')) {
        relanceVue = true; window.location.href = '/checkout'; return;
      }
    });
  }
  if (keepBtn) keepBtn.addEventListener('click', () => close());
  // 31/10/2026 : un geste sur un article du bloc « Pour compléter votre panier » l'ajoute.
  linesEl.addEventListener('click', e => {
    const b = e.target.closest('[data-cplt]'); if (!b) return;
    e.preventDefault(); b.disabled = true;
    add(parseInt(b.dataset.cplt, 10), 1).then(ok => { if (!ok) b.disabled = false; });
  });
  const upgBox = dr.querySelector('.cart-upg');
  if (upgBox) upgBox.addEventListener('click', e => {
    const b = e.target.closest('[data-upg]');
    if (!b || busy || !upgBox._o || !window.eslPackPrendre) return;
    busy = true; b.disabled = true; dr.setAttribute('aria-busy', 'true');
    window.eslPackPrendre(upgBox._o).then(c => { busy = false; dr.setAttribute('aria-busy', 'false'); if (c) render(c); else refresh(); });
  });
  // Le lien Commander ouvre directement le paiement Shopify.

  // ---- barre panier toujours visible (mobile) ----
  const barre = document.createElement('div');
  barre.className = 'cartbar';
  barre.setAttribute('hidden', '');
  barre.innerHTML = '<p class="cartbar__ship" aria-live="polite" style="display:none"></p>' +
    '<div class="cartbar__row">' +
      '<button type="button" class="cartbar__open" aria-label="Voir mon panier">' +
        '<span class="cartbar__n">0</span><span class="cartbar__lbl">Mon panier</span>' +
        '<span class="cartbar__tot">0,00 €</span></button>' +
      '<a href="/checkout" class="cartbar__go">Commander</a>' +
    '</div>';
  document.body.appendChild(barre);
  barre.querySelector('.cartbar__open').addEventListener('click', () => open());
  // Le lien Commander ouvre directement le paiement Shopify.

  function hauteurBanniere() {
    const b = document.getElementById('shopify-pc__banner');
    if (!b) return 0;
    const r = b.getBoundingClientRect();
    // bannière réellement visible à l'écran ?
    return (r.height > 0 && r.bottom > window.innerHeight - 8) ? r.height : 0;
  }
  function calerBarre() {
    const h = hauteurBanniere();
    barre.style.bottom = h ? h + 'px' : '0px';
    document.body.style.setProperty('--cartbar-h', (barre.offsetHeight + h) + 'px');
  }
  window.addEventListener('resize', calerBarre);
  const obsBan = new MutationObserver(() => calerBarre());
  obsBan.observe(document.body, { childList: true, subtree: false });
  window.setTimeout(calerBarre, 1200);

  function majBarre(total, n) {
    if (!n) { barre.setAttribute('hidden', ''); document.body.classList.remove('has-cartbar'); return; }
    barre.removeAttribute('hidden'); document.body.classList.add('has-cartbar');
    barre.querySelector('.cartbar__n').textContent = n;
    barre.querySelector('.cartbar__tot').textContent = fmt(total);
    calerBarre();
    const sh = barre.querySelector('.cartbar__ship');
    if (total >= FREE_SHIP) sh.innerHTML = '&#10003; Livraison en point relais offerte';
    else sh.innerHTML = 'Plus que <b>' + fmt(FREE_SHIP - total) + '</b> pour la livraison offerte';
  }

  linesEl.addEventListener('click', e => {
    const b = e.target.closest('[data-key]'); if (!b) return;
    change(b.dataset.key, parseInt(b.dataset.q, 10), b);
  });
  const focusable = () => Array.from(dr.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')).filter(el => el.offsetParent !== null);
  const open = () => {
    const alreadyOpen = dr.classList.contains('open');
    if (!alreadyOpen) lastFocus = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    if (!alreadyOpen) setCartBackgroundInert(true);
    ov.classList.add('open'); dr.classList.add('open'); dr.setAttribute('aria-hidden', 'false'); document.body.classList.add('scroll-lock');
    if (!alreadyOpen) requestAnimationFrame(() => dr.querySelector('.cart-drawer__close').focus());
  };
  const close = () => {
    ov.classList.remove('open'); dr.classList.remove('open');
    dr.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('scroll-lock');
    setCartBackgroundInert(false);
    if (lastFocus && document.contains(lastFocus)) lastFocus.focus();
    lastFocus = null;
  };
  document.addEventListener('keydown', e => {
    if (!dr.classList.contains('open')) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    const controls = focusable();
    if (!controls.length) { e.preventDefault(); dr.focus(); return; }
    const first = controls[0], last = controls[controls.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  ov.addEventListener('click', close);
  dr.querySelector('.cart-drawer__close').addEventListener('click', close);
  const cb = document.getElementById('cartBtn'); if (cb) cb.addEventListener('click', e => { e.preventDefault(); refresh(); open(); });

  function bindAdd(scope) {
    const oos = window.ESL_OOS || [];
    (scope || document).querySelectorAll('.add:not([data-bound])').forEach(btn => {
      btn.setAttribute('data-bound', '1');
      const bvid = btn.dataset.variantId;
      if (bvid && oos.indexOf(parseInt(bvid, 10)) >= 0) {
        btn.textContent = 'Bientôt';
        btn.classList.add('btn--soon');
        btn.addEventListener('click', e => {
          e.preventDefault();
          const card = btn.closest('article, .packcard, .lvl-up, .pdp-upsell');
          const lnk = card && card.querySelector('a[href*="/products/"]');
          if (lnk) window.location.href = lnk.getAttribute('href');
        });
        return;
      }
      btn.addEventListener('click', e => {
        e.preventDefault();
        const vid = btn.dataset.variantId;
        if (vid && !btn.dataset.href) {
          add(vid, 1).then(ok => {
            if (!ok) return;
            // sceau frappé : feedback royal sur le bouton, seulement si l'ajout a abouti
            btn.classList.add('sealed');
            setTimeout(() => btn.classList.remove('sealed'), 950);
          });
        }
        else if (btn.dataset.href) { window.location.href = btn.dataset.href; }
      });
    });
  }
  bindAdd(document);
  refresh();
  return { refresh: refresh, add: add, open: open, close: close, bindAdd: bindAdd };
})();

/* ===== COIN ÉCOUTE : le podcast maison, ouvert dans un panneau (plus de musique de fond) ===== */
(function () {
  const dock = document.createElement('div'); dock.className = 'audiodock';
  dock.innerHTML =
    '<button class="audiodock__pill audiodock__pod" type="button" aria-expanded="false" aria-controls="eslPod" aria-label="Écouter nos contes du soir"><span class="audiodock__ic">🎧</span><span class="audiodock__lbl">Contes du soir</span></button>';
  const mobileDock = window.matchMedia('(max-width: 1080px)');
  const nav = document.getElementById('nav');
  const mountDock = () => {
    if (mobileDock.matches && nav) nav.appendChild(dock);
    else document.body.appendChild(dock);
  };
  mountDock();
  if (mobileDock.addEventListener) mobileDock.addEventListener('change', mountDock);
  else mobileDock.addListener(mountDock);

  const btn = dock.querySelector('.audiodock__pod');
  let panneau = null;

  function construire() {
    panneau = document.createElement('div');
    panneau.className = 'eslpod'; panneau.id = 'eslPod'; panneau.hidden = true;
    panneau.innerHTML =
      '<div class="eslpod__tete"><strong>Louise et Joseph, l\'Histoire du Soir</strong>' +
      '<button class="eslpod__x" type="button" aria-label="Fermer le lecteur">×</button></div>' +
      '<iframe title="Lecteur du podcast Histoire du Soir" loading="lazy" frameborder="0" ' +
      'src="https://player.ausha.co/?color=%23c8973a&dark=false&playerId=eslpod-dock&podcastId=&showId=8R4n3UpXrRpM&v=3"></iframe>' +
      '<a class="eslpod__plus" href="/pages/podcast">Tous les épisodes, et notre second podcast →</a>';
    document.body.appendChild(panneau);
    panneau.querySelector('.eslpod__x').addEventListener('click', () => basculer(false));
  }

  function basculer(ouvrir) {
    if (!panneau) construire();
    const cible = ouvrir === undefined ? panneau.hidden : ouvrir;
    panneau.hidden = !cible;
    btn.setAttribute('aria-expanded', cible ? 'true' : 'false');
    btn.classList.toggle('playing', cible);
    if (cible) panneau.querySelector('.eslpod__x').focus();
  }

  btn.addEventListener('click', () => basculer());
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && panneau && !panneau.hidden) { basculer(false); btn.focus(); }
  });
})();

/* ===== IMMERSION : liseré de progression doré + voile d'entrée ===== */
(function () {
  const p = document.createElement('div'); p.id = 'eslProg'; document.body.appendChild(p);
  let raf = null;
  const upd = () => { raf = null;
    const h = document.documentElement, max = h.scrollHeight - h.clientHeight;
    p.style.width = (max > 0 ? (h.scrollTop || document.body.scrollTop) / max * 100 : 0) + '%';
  };
  window.addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(upd); }, { passive: true });
  if (!document.querySelector('[data-slshop], .pdp, .cartpage')) {
    const v = document.createElement('div'); v.className = 'eslveil'; document.body.appendChild(v);
    const leverVoile = () => { v.classList.add('off'); setTimeout(() => { if (v.parentNode) v.remove(); }, 550); };
    requestAnimationFrame(() => requestAnimationFrame(leverVoile));
    /* Filet : un onglet ouvert en arriere-plan ne declenche pas requestAnimationFrame,
       le voile resterait alors en place et la page paraitrait vide. */
    setTimeout(leverVoile, 1800);
    document.addEventListener('visibilitychange', () => { if (!document.hidden) leverVoile(); }, { once: true });
  }
})();

/* ===== COOKIES / RGPD : bannière native Shopify (Customer Privacy), habillée en CSS ===== */

/* ===== RECHERCHE (overlay, index chargé au premier clic) ===== */
(function () {
  const btns = document.querySelectorAll('.icon-btn[aria-label="Rechercher"]');
  if (!btns.length) return;
  let ov = null, inp = null, res = null, status = null, loaded = false, lastFocus = null, inertedBySearch = [];
  const norm = s => (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  const safe = value => String(value == null ? '' : value).replace(/[&<>"']/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char]);
  function build() {
    ov = document.createElement('div'); ov.className = 'search-ov'; ov.setAttribute('aria-hidden', 'true'); ov.inert = true;
    ov.innerHTML = '<div class="search-box" role="dialog" aria-modal="true" aria-labelledby="searchTitle"><h2 class="sr-only" id="searchTitle">Rechercher sur le site</h2><div class="search-row"><input type="search" placeholder="Un héros, un livre, un puzzle…" aria-labelledby="searchTitle" /><button class="search-close" type="button" aria-label="Fermer la recherche">×</button></div><p class="sr-only search-status" role="status"></p><div class="search-res" aria-label="Résultats de recherche"></div></div>';
    document.body.appendChild(ov);
    inp = ov.querySelector('input'); res = ov.querySelector('.search-res'); status = ov.querySelector('.search-status');
    ov.addEventListener('click', e => { if (e.target === ov) close(); });
    ov.querySelector('.search-close').addEventListener('click', close);
    document.addEventListener('keydown', e => {
      if (!ov || !ov.classList.contains('open')) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab') return;
      const controls = Array.from(ov.querySelectorAll('a[href],button:not([disabled]),input:not([disabled])')).filter(element => element.offsetParent !== null);
      if (!controls.length) return;
      const first = controls[0], last = controls[controls.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    inp.addEventListener('input', () => draw(inp.value));
  }
  function draw(q) {
    const hiddenProducts = new Set(['/products/pack-clotilde-clovis', '/products/pack-integrale-puzzles', '/products/integrale-heros-de-france']);
    const unique = new Map();
    (window.ESL_INDEX || []).forEach(item => {
      const key = item && item.u ? item.u : item && item.t;
      if (!key || hiddenProducts.has(item.u)) return;
      const previous = unique.get(key);
      if (!previous || (!previous.i && item.i)) unique.set(key, item);
    });
    const list = Array.from(unique.values());
    q = norm(q).trim();
    let hits = !q ? list.slice(0, 8) : list.filter(it => norm(it.t + ' ' + it.k).indexOf(q) >= 0).slice(0, 10);
    if (status) status.textContent = q ? hits.length + ' résultat' + (hits.length > 1 ? 's' : '') + ' pour ' + q : 'Suggestions de la boutique';
    res.innerHTML = hits.length
      ? hits.map(it => '<a class="search-hit" href="' + safe(it.u) + '">' + (it.i ? '<img loading="lazy" decoding="async" src="' + safe(it.i) + '" width="44" height="44" alt="" />' : '<span class="search-hit__ph">⚜</span>') + '<span class="search-hit__t"><strong>' + safe(it.t) + '</strong>' + (it.b ? '<em>' + safe(it.b) + '</em>' : '') + '</span>' + (it.p ? '<b>' + safe(it.p) + '</b>' : '') + '</a>').join('')
      : '<p class="search-none">Rien trouvé pour « ' + safe(q) + ' ». Essayez un nom de héros : Jeanne, Clovis, Napoléon…</p>';
  }
  function loadIndex() {
    if (loaded || window.ESL_INDEX) { loaded = true; draw(inp.value); return; }
    loaded = true;
    const script = document.createElement('script');
    script.src = (window.ESL_ASSETS && window.ESL_ASSETS.search) || 'search-index.js';
    script.onload = () => draw(inp.value);
    script.onerror = () => {
      loaded = false;
      res.innerHTML = '<div class="search-none" role="alert">La recherche n’a pas pu être chargée.<br><button class="btn btn--mini search-retry" type="button">Réessayer</button></div>';
      const retry = res.querySelector('.search-retry');
      if (retry) retry.addEventListener('click', loadIndex, { once: true });
    };
    document.head.appendChild(script);
  }
  function open() {
    if (!ov) build();
    lastFocus = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    inertedBySearch = Array.from(document.body.children).filter(element => element !== ov && !element.inert);
    inertedBySearch.forEach(element => { element.inert = true; });
    loadIndex();
    ov.inert = false; ov.setAttribute('aria-hidden', 'false'); ov.classList.add('open'); draw(''); setTimeout(() => inp.focus(), 60);
    document.body.classList.add('scroll-lock');
  }
  function close() {
    if (!ov || !ov.classList.contains('open')) return;
    ov.classList.remove('open'); ov.setAttribute('aria-hidden', 'true'); ov.inert = true;
    document.body.classList.remove('scroll-lock');
    inertedBySearch.forEach(element => { element.inert = false; });
    inertedBySearch = [];
    if (lastFocus && document.contains(lastFocus)) lastFocus.focus();
    lastFocus = null;
  }
  btns.forEach(b => b.addEventListener('click', open));
})();

/* ===== MON PANTHÉON : trace des rencontres (pages hero-*) ===== */
(function () {
  var m = location.pathname.match(/hero-([a-z]+)\.html$/);
  if (!m) return;
  try {
    var k = 'esl_heroes_met', l = JSON.parse(localStorage.getItem(k) || '[]');
    if (l.indexOf(m[1]) < 0) { l.push(m[1]); localStorage.setItem(k, JSON.stringify(l)); }
  } catch (e) {}
})();

/* ===== Pack mouvement : cascade, poussière d'or, compteurs ===== */
(function () {
  // cascade : délai selon la position parmi les frères révélés
  document.querySelectorAll('.reveal').forEach(el => {
    const sibs = el.parentElement ? Array.from(el.parentElement.children).filter(c => c.classList.contains('reveal')) : [el];
    el.style.setProperty('--stag', Math.min(sibs.indexOf(el), 7));
  });
  // poussière d'or sur les bandeaux sombres (léger : 5 particules max)
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.pagehero, .section--ink, .fidelite').forEach(sec => {
      for (let i = 0; i < 5; i++) {
        const d = document.createElement('i');
        d.className = 'gdust';
        d.style.left = (8 + Math.random() * 84) + '%';
        d.style.bottom = (Math.random() * 55) + '%';
        d.style.setProperty('--gd', (7 + Math.random() * 6) + 's');
        d.style.setProperty('--gdd', (Math.random() * 6) + 's');
        sec.appendChild(d);
      }
    });
  }
  // compteurs : les <b>N points</b> / <b>N €</b> de la cagnotte comptent jusqu'à leur valeur
  const cnt = document.querySelectorAll('.cagn__row b, .cagnmini__v b');
  if ('IntersectionObserver' in window && cnt.length) {
    const io2 = new IntersectionObserver(es => {
      es.forEach(e => {
        if (!e.isIntersecting) return;
        io2.unobserve(e.target);
        const txt = e.target.textContent;
        const mnum = txt.replace(/\s/g, '').match(/^([0-9]+)/);
        if (!mnum) return;
        const target = parseInt(mnum[1], 10);
        if (!target || target < 2) return;
        const suffix = txt.replace(/^[0-9\s]+/, '');
        const t0 = performance.now(), dur = 1200;
        (function tick(now) {
          const p = Math.min(1, (now - t0) / dur);
          const v = Math.round(target * (1 - Math.pow(1 - p, 3)));
          e.target.textContent = v.toLocaleString('fr-FR') + (suffix ? ' ' + suffix : '');
          if (p < 1) requestAnimationFrame(tick);
        })(t0);
      });
    }, { threshold: 0.4 });
    cnt.forEach(el => io2.observe(el));
  }
})();
